// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"ac11cd60","496":"f99e46d0","933":"0873df6a"}[chunkId] + ".chunk.css";
};